import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { noop } from 'Utils';
import ModalHeader from '../ModalHeader';
import { PinInput } from './PinInput';
import { Device } from 'DeviceUtils';
import defaultStyles from './PinInputModal.jss';

const PinInputModal = (props) => {
    const { onCancel, opaque } = props;
    const [fullScreenWasOpened, setFullScreenWasOpened] = useState(false);
    useEffect(() => {
        if (Device.isWeb && document.fullscreenElement) {
            if (document && document.exitFullscreen) {
                setFullScreenWasOpened(true);
                const playerDOMElement = document.getElementById('player');
                if (playerDOMElement) {
                    document.exitFullscreen();
                }

                return () => {
                    if (fullScreenWasOpened) playerDOMElement.requestFullscreen();
                };
            }
        }
    }, []);

    return (
        <View
            style={[
                defaultStyles.container,
                Boolean(onCancel) && defaultStyles.backdrop,
                opaque && defaultStyles.opaque
            ]}
        >
            {onCancel && <ModalHeader onPress={() => onCancel()} />}
            <PinInput {...props} />
        </View>
    );
};

PinInputModal.defaultProps = {
    message: null,
    showDefaultPin: false,
    onForgotPinPressed: null,
    onPinFailed: null,
    invalidPinMessage: null,
    onCancel: noop,
    opaque: false
};

PinInputModal.propTypes = {
    header: PropTypes.string.isRequired,
    message: PropTypes.string,
    showDefaultPin: PropTypes.bool,
    onPinSuccess: PropTypes.func.isRequired,
    onPinFailed: PropTypes.func,
    onForgotPinPressed: PropTypes.func,
    pinValidateFunction: PropTypes.func.isRequired,
    invalidPinMessage: PropTypes.string,
    onCancel: PropTypes.func,
    opaque: PropTypes.bool
};

export { PinInputModal };
